import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { getActivePrintListAction, handleAutoPrintAction, printByOrderNumber } from '../../../store/actions/barcode.action';
import './index.css';
import { Button } from "bootstrap-4-react/lib/components";
import { useNavigate } from 'react-router-dom';
import { useTextToSpeech } from '../../../config/utils';
import LoaderSpinner from '../../common/Loader';
/* istanbul ignore next */
const PrintByOrderNumber = () => {
    const [orderNumber, setOrderNumber] = useState('');
    const [loading, setLoading] = useState(false);
    let inputRef = React.useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { handleSpeak } = useTextToSpeech();
    const [pdfBase64, setPdfBase64] = useState("");
    const handleAutoPrint = async (base64Pdf) => {
        try {
            const res = await getActivePrintListAction();
            let printerList = res?.data?.data;
            if (printerList?.length) {
                let findActive = printerList.filter((printer) => printer.isDefault);
                if (findActive.length) {
                    let data = {
                        PrinterName: findActive[0].printerName,
                        FileBase64: `${base64Pdf}`,
                        width: 4,
                        height: 6
                    };
                    handleAutoPrintAction(data).then((res) => {
                        handleSpeak("Print successfully");
                    });
                }
            } else {
                toast.error("Something went wrong")
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleDownload = (base64Pdf) => {
        const linkSource = `data:application/pdf;base64,${base64Pdf}`;
        const downloadLink = document.createElement("a");
        const fileName = `label_${orderNumber}.pdf`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        toast.success("Download successfully");
    };

    const handlePrint = () => {
        if (!orderNumber || orderNumber.toString().trim() === '') {
            toast.error('Please enter an order number');
            return;
        }
        setLoading(true);
        const payload = { orderNumber: orderNumber.trim() };
        dispatch(printByOrderNumber(payload))
            .then((result) => {
                if (result && result.data.Status === 200) {
                    setPdfBase64(result.data.Entity.labelBase64);
                    handleAutoPrint(result.data.Entity.labelBase64);
                    handleDownload(result.data.Entity.labelBase64);
                    toast.success('Print request sent successfully');
                    inputRef.current.focus();
                } else {
                    toast.error('Print request failed');
                    setPdfBase64("");
                }
            })
            .catch((err) => {
                setOrderNumber('');
                const msg = err?.response?.data?.Message?.AppStatusDescription || err?.message || 'Print request failed';
                toast.error(msg);
            })
            .finally(() => {
                setLoading(false);
                setOrderNumber('');
                inputRef.current.focus();
            });
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec custitle">
                    Print by Order Number
                    <div className="top_right_button_container">
                        <Button
                            className="cus-primary-transparent-btn"
                            onClick={() => {
                                navigate("/barcode");
                            }}
                            disabled={loading}
                        >
                            Back
                        </Button>
                    </div>
                </div>

                {loading && <LoaderSpinner />}
                <div className="main_content cus-page-content-sec incomingTbl">
                    <div className="top_right_button_container cus-content-only-sec">
                        <div className="incoming_wrapper addressDetailWrapper fontFix">
                            <div className="print-by-order-number print-by-order-number--center">
                                <input
                                    className="print-by-order-number__input form-control"
                                    type="text"
                                    ref={inputRef}
                                    value={orderNumber}
                                    placeholder="Enter Order Number"
                                    onChange={(e) => setOrderNumber(e.target.value)}
                                    onBlur={(e) => setOrderNumber(e.target.value.trim())}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handlePrint();
                                        }
                                    }}
                                    autoFocus
                                />
                                <button
                                    className="print-by-order-number__button"
                                    onClick={handlePrint}
                                    disabled={loading}
                                >
                                    {loading ? 'Printing...' : 'Print'}
                                </button>
                            </div>
                        </div>

                        <div className="mt-5 alignCenter">
                            {pdfBase64 && (
                                <embed
                                    src={`data:application/pdf;base64,${pdfBase64}#view=fit`}
                                    height="475px"
                                    width="100%"
                                    title="PDF"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default PrintByOrderNumber;